import { render, staticRenderFns } from "./somaterilnew.vue?vue&type=template&id=1055ee6b&scoped=true&"
import script from "./somaterilnew.vue?vue&type=script&lang=js&"
export * from "./somaterilnew.vue?vue&type=script&lang=js&"
import style0 from "./somaterilnew.vue?vue&type=style&index=0&id=1055ee6b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1055ee6b",
  null
  
)

export default component.exports